import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  position: relative;
  &::before {
    position: absolute;
    inset: var(--inset);
    opacity: 0;
    transition: opacity 220ms ease-in;
    background: radial-gradient(
      ellipse 40% 8px at var(--side),
      var(--color) 0%,
      var(--color) 20%,
      transparent 100%
    );
    filter: blur(2px);
    content: '';
  }
  &.lateral::before {
    background: radial-gradient(
      ellipse 8px 40% at var(--side),
      var(--color) 0%,
      var(--color) 20%,
      transparent 100%
    );
  }
  &::after {
    position: absolute;
    inset: var(--inset);
    background: radial-gradient(
      ellipse 50% 40px at var(--side),
      var(--color) 0%,
      var(--color) 20%,
      transparent 100%
    );
    filter: blur(8px);
    opacity: 0;
    transition: opacity 220ms ease-in;
    z-index: -1;
    content: '';
  }
  &.lateral::after {
    background: radial-gradient(
      ellipse 40px 50% at var(--side),
      var(--color) 0%,
      var(--color) 20%,
      transparent 100%
    );
  }
  &.show-neon {
    &::before {
      opacity: 1;
    }
  }
  &.show-neon-on-hover:hover::before {
    opacity: 1;
  }
  &.show-halo::after {
    opacity: 0.3;
  }
  &.show-halo-on-hover:hover::after {
    opacity: 0.3;
  }
`;

type Props = {
  color: string;
  children?: ReactNode;
  showNeon?: 'always' | 'hover' | 'never';
  showHalo?: 'always' | 'hover' | 'never';
  className?: string;
  inset?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
};
export const NeonEdge = ({
  color,
  children,
  showNeon = 'always',
  showHalo = 'hover',
  className,
  inset = '0',
  side = 'bottom',
}: Props) => {
  return (
    <Root
      style={
        { '--color': color, '--inset': inset, '--side': side } as CSSProperties
      }
      className={classNames(
        {
          'show-neon': showNeon === 'always',
          'show-neon-on-hover': showNeon === 'hover',
          'show-halo': showHalo === 'always',
          'show-halo-on-hover': showHalo === 'hover',
          lateral: side === 'left' || side === 'right',
        },
        className
      )}
    >
      {children}
    </Root>
  );
};
